import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(theme => ({
  row: {
    marginBottom: theme.spacing(4),
    display: 'flex'
  },
  empty: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(10, 20)
  },
  storyHighlights: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '6px',
    backgroundColor: '#FFFFFF',
    padding: theme.spacing(1),
    margin: 0
  },
  label: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    color: '#8688A1',
    marginBottom: '4px'
  },
  icon: {
    marginBottom: '4px'
  },
  header: {
    color: '#8688A1',
    marginBottom: '8px'
  },
  text: {
    fontSize: '14px',
    letterSpacing: 0,
    lineHeight: '21px',
    color: '#8688A1',
    fontWeight: 'normal',
    textAlign: 'center'
  }
}))
